<script setup lang="ts">
const { showMoneyFormat } = useWallet();
const { parameters } = useParameters();
const { t } = useTexts();
const firstDepositBonus = computed(() => {
  if (!parameters.value?.max_deposit_bonus) {
    return;
  }

  return `${parameters.value?.first_deposit_bonus}% ${t('account.wallet.bonus_rules_modal.up_to')} ${showMoneyFormat({ value: parameters.value?.max_deposit_bonus / 100 })}`;
});

const casinoBetsMultiply = computed(() => {
  return `${parameters.value?.casino?.rollOverMultiplier}x`;
});

const sportsBetsMultiply = computed(() => {
  return `${parameters.value?.multiplier_to_allow_first_withdraw}x`;
});

const rolloverCasinoExpiresIn = computed(() => {
  return `${parameters.value?.rollover_casino_expires_in} ${t('account.wallet.bonus_rules_modal.hour')}`;
});

const rolloverSportsExpiresIn = computed(() => {
  return `${parameters.value?.rollover_sports_expires_in} ${t('account.wallet.bonus_rules_modal.hour')}`;
});

const maxBonusWithdrawalMultiply = computed(() => {
  if (!parameters.value?.qtd_withdrawal_bonus) {
    return '1x';
  }

  return `${parameters.value?.qtd_withdrawal_bonus}x`;
});
</script>

<template>
  <ClientOnly>
    <div class="flex flex-col p-6">
      <div class="flex">
        <NuxtIcon name="withdraw" />
        <h6 class="text-lg mb-4 ml-4 text-white font-extrabold">
          {{ $t('account.wallet.bonus_rules_modal.title') }}
        </h6>
      </div>

      <div class="rules-box">
        <article class="rules-rows">
          <p v-if="firstDepositBonus">
            {{ $t('account.wallet.bonus_rules_modal.first_deposit_bonus') }}:
            <span>{{ firstDepositBonus }}</span>
          </p>
          <p>
            {{ $t('account.wallet.bonus_rules_modal.casino_bets') }}:
            <span>{{ casinoBetsMultiply }}</span>
          </p>
          <p>
            {{ $t('account.wallet.bonus_rules_modal.sports_bets') }}:
            <span> {{ sportsBetsMultiply }} </span>
          </p>
          <p>
            {{ $t('account.wallet.bonus_rules_modal.casino_expiry_time') }}:
            <span>{{ rolloverCasinoExpiresIn }}</span>
          </p>
          <p>
            {{ $t('account.wallet.bonus_rules_modal.sports_expiry_time') }}:
            <span>{{ rolloverSportsExpiresIn }}</span>
          </p>
          <p>
            {{ $t('account.wallet.bonus_rules_modal.max_bonus_withdrawal') }}:
            <span>{{ maxBonusWithdrawalMultiply }}</span>
          </p>
        </article>
        <hr />
        <article class="rules-warning">
          <div class="flex items-center">
            <NuxtIcon name="exclamation" />
            <h4 class="m-0 p-0">
              {{
                $t('account.wallet.bonus_rules_modal.bonus_withdrawal_rules')
              }}
            </h4>
          </div>
          <p>
            <strong>
              {{ $t('account.wallet.bonus_rules_modal.casino') }}:
            </strong>
            <br />
            {{
              $t(
                'account.wallet.bonus_rules_modal.bonus_withdrawal_casino_rules',
              )
            }}
          </p>
          <p>
            <strong>
              {{ $t('account.wallet.bonus_rules_modal.sports') }}:
            </strong>
            <br />
            {{
              $t(
                'account.wallet.bonus_rules_modal.bonus_withdrawal_sports_rules',
              )
            }}
          </p>
          <p>
            {{ $t('account.wallet.bonus_rules_modal.use_bonus_balance') }}
          </p>
        </article>
      </div>
    </div>
  </ClientOnly>
</template>

<style lang="scss">
.rules-title {
  @apply text-primary text-xl font-bold mb-4;
}
.rules-box {
  @apply text-texts bg-white/[.08] p-6 rounded-lg;
  * {
    @apply mb-2;
  }
  .rules-rows {
    p {
      @apply mb-3 text-xs text-texts/60 font-bold;
      span {
        @apply ml-2 p-1 text-2xs bg-primary/10 text-primary;
      }
    }
  }
  hr {
    @apply mt-4 text-texts/20;
  }
  .rules-warning {
    @apply gap-2 text-warning text-xs mb-0 mt-4 border-t border-warning;
    p {
      @apply my-4 mx-0.5 border-l border-warning border-solid pl-3;
      &:last-of-type {
        @apply mb-1;
      }
    }
    h4 {
      @apply font-normal;
    }
    svg {
      @apply h-8 w-8 min-w-8 mb-0 mr-3;
    }
  }
}
</style>
